<!--
    描述：头部 选项卡
    时间：2020-04-21
    Created by ws
-->
<template>
	<div class="h100 tags-main">
		<router-link class="tags-item"
					 :class="{'is-active': isActive(item)}"
					 v-for="(item, index) in tagsList"
					 :to="{ path: item.path, query: item.query, fullPath: item.fullPath }"
					 :key="item.path"
					 tag="span"
					 @contextmenu.prevent.native="openMenu(item, $event)">
			{{ item.title }}
			<span v-if="item.name !== 'Home'"
				  class="el-icon-close"
				  @click.prevent.stop="closeSelectedTag(item)" />
		</router-link>

		<!-- 右键菜单 -->
		<ul v-show="context.visible"
			:style="{left: `${context.left}px`, top: `${context.top}px`}"
			class="contextmenu">
			<li @click="doRefresh">刷新</li>
			<li @click="doClose" v-if="context.selectTag.name !== 'Home'">关闭</li>
			<li @click="doCloseOthers">关闭其他</li>
			<li @click="doCloseAll">关闭所有</li>
		</ul>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
	data() {
		return {
			// tagsList: []
			context: {
				visible: false,
				top: 0,
				left: 0,
				selectTag: {}
			}
		}
	},
	methods: {
		...mapActions('tags', ['addView', 'delView', 'delCacheView', 'delOtherView', 'delAllViews']),
		// 打开右键菜单
		openMenu(tag, e) {
			const menuMinWidth = 85
			const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
			const offsetWidth = this.$el.offsetWidth // container width
			const maxLeft = offsetWidth + offsetLeft - menuMinWidth
			const left = e.clientX + 10 // 15: margin right

			if (left > maxLeft) {
				this.context.left = maxLeft
			} else {
				this.context.left = left
			}

			this.context.top = this.showHeader ? e.clientY - 50 : e.clientY
			this.context.visible = true
			this.context.selectTag = tag
		},

		// 初始默认渲染 首页 tag
		initTag() {
			let _home = this.routeList.find(x => x.name === 'Home')
			if (_home) {
				this.addView(_home)
			}
		},

		// 新增tags
		addTags() {
			const { name } = this.$route
			if (name) {
				this.addView(this.$route)
			}
			return false
		},

		// 关闭当前选择的 tag
		closeSelectedTag(item) {
			this.delView(item).then(res => {
				// console.log(res)
				// 如果删除的是 选中的，那么 将当前tags 的最后一个选中
				if (this.isActive(item)) {
					this.toLastTag(res)
				}
			})
		},

		// 判断当前的 tag 是不是高亮选中的
		isActive(route) {
			return route.path === this.$route.path
		},

		// 让最后 一个tag 变为选中
		toLastTag(res) {
			let _last = res.tagsList[res.tagsList.length - 1]

			if (_last) {
				this.$router.push(_last)
			}
		},

		// 右键菜单---点击刷新
		doRefresh() {
			// 先删除缓存页面
			this.delCacheView(this.context.selectTag).then(res => {
				const { path } = this.context.selectTag

				this.$nextTick(() => {
					this.$router.replace({
						path: '/redirect' + path
					})
				})
			})
		},

		// 右键菜单---点击关闭
		doClose() {
            this.delView(this.context.selectTag).then(res => {
                // console.log(res)
				// 如果删除的是 选中的，那么 将当前tags 的最后一个选中
				if (this.isActive(this.context.selectTag)) {
					this.toLastTag(res)
				}
			})
        },

		// 右键菜单---点击关闭其他
		doCloseOthers() {
			this.delOtherView(this.context.selectTag).then(res => {
				const { path } = this.context.selectTag

				this.$nextTick(() => {
					this.$router.push({
						path: path
					})
				})
			})
		},

		// 右键菜单---点击关闭全部
		doCloseAll() {
			this.delAllViews().then(res => {

				this.$nextTick(() => {
					this.$router.push({
						path: 'home'
					})
				})
			})
		},

		// 关闭右键菜单
		closeMenu() {
			this.context.visible = false
		}
	},
	created() {
		// 初始渲染
		this.initTag()
		this.addTags()
	},
	computed: {
		...mapState('settings', {
			showHeader: state => state.showHeader
		}),
		...mapState('tags', {
			tagsList: state => state.tagsList
		}),
		...mapState('menu', {
			routeList: state => state.routeList
		})
	},
	watch: {
		// 监听路由 动态增加tag
		$route() {
			this.addTags()
		},
		// 监听点击事件， 关闭右键菜单
		'context.visible': {
			handler: function(value) {
				if (value) {
					document.body.addEventListener('click', this.closeMenu)
				} else {
					document.body.removeEventListener('click', this.closeMenu)
				}
			},
			deep: true
		}
	}
}
</script>

<style scoped lang="less">
.tags-main {
	.tags-item {
		display: inline-block;
		padding: 0 7px;
		border: 1px solid #ccc;
		height: 24px;
		line-height: 24px;
		font-size: 12px;
		margin-right: 5px;
		cursor: pointer;
	}

	.is-active {
		background-color: #42b983;
		color: #fff;
		border-color: #42b983;
		&::before {
			content: '';
			background: #fff;
			display: inline-block;
			width: 8px;
			height: 8px;
			border-radius: 50%;
			position: relative;
			margin-right: 3px;
		}
	}

	.el-icon-close {
		margin-left: 3px;
		border-radius: 50%;
		padding: 2px;

		&:hover {
			background-color: #2c3e50;
			line-height: 13px;

			&:before {
				color: #fff;
			}
		}
	}

	.contextmenu {
		margin: 0;
		width: 85px;
		background: #fff;
		z-index: 100;
		position: absolute;
		list-style-type: none;
		padding: 5px 0;
		border-radius: 4px;
		font-size: 12px;
		font-weight: 400;
		color: #333;
		box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
		li {
			margin: 0;
			height: 30px;
			line-height: 30px;
			padding: 0 10px;
			border-bottom: 1px solid #ddd;
			cursor: pointer;
			&:hover {
				background: #eee;
			}
		}

		li:last-child {
			border: none;
		}
	}
}
</style>
